/**
 * Centralized Timezone Configuration
 * Single source of truth for all timezone dropdowns across the app
 */

export const TIMEZONES = [
  { value: 'Asia/Dubai', label: 'GST (Gulf) - Dubai/UAE', abbr: 'GST' },
  { value: 'America/New_York', label: 'EST (Eastern)', abbr: 'EST' },
  { value: 'America/Chicago', label: 'CST (Central)', abbr: 'CST' },
  { value: 'America/Denver', label: 'MST (Mountain)', abbr: 'MST' },
  { value: 'America/Phoenix', label: 'MST (Arizona)', abbr: 'MST' },
  { value: 'America/Los_Angeles', label: 'PST (Pacific)', abbr: 'PST' },
  { value: 'America/Anchorage', label: 'AKST (Alaska)', abbr: 'AKST' },
  { value: 'Pacific/Honolulu', label: 'HST (Hawaii)', abbr: 'HST' }
];

/**
 * Get timezone abbreviation from IANA timezone value
 * @param {string} timezone - IANA timezone (e.g., 'Asia/Dubai')
 * @returns {string} Abbreviation (e.g., 'GST')
 */
export const getTimezoneAbbr = (timezone) => {
  const tz = TIMEZONES.find(t => t.value === timezone);
  return tz?.abbr || 'CST'; // Default to CST if not found
};

/**
 * Get timezone label from IANA timezone value
 * @param {string} timezone - IANA timezone (e.g., 'Asia/Dubai')
 * @returns {string} Label (e.g., 'GST (Gulf) - Dubai/UAE')
 */
export const getTimezoneLabel = (timezone) => {
  const tz = TIMEZONES.find(t => t.value === timezone);
  return tz?.label || 'CST (Central)';
};

/**
 * Default timezone (Gulf/Dubai for primary market)
 */
export const DEFAULT_TIMEZONE = 'Asia/Dubai';
